var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('funcionalidade-header',{attrs:{"titulo":_vm.funcionalidade.nome}}),_c('ErrorLayout',{attrs:{"showBtn":false,"texto":_vm.texto,"titulo":_vm.titulo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }